import React from "react";
import { createSvgIcon } from '@mui/material';
import Styled from "./custom-styled-icon";

export const StackedLayer = Styled(
  createSvgIcon(
    <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.4" d="M22.1348 6.51107V9.87565C22.1348 12.2611 21.3743 13.0215 18.9889 13.0215H18.8848V11.3132C18.8848 8.06316 17.4368 6.61523 14.1868 6.61523H12.4785V6.51107C12.4785 4.12566 13.2389 3.36523 15.6243 3.36523H18.9889C21.3743 3.36523 22.1348 4.12566 22.1348 6.51107Z" fill="currentColor"/>
      <path d="M17.3236 11.3132V14.6882C17.3236 17.0632 16.5632 17.8236 14.1882 17.8236H10.8132C8.43815 17.8236 7.67773 17.0632 7.67773 14.6882V11.3132C7.67773 8.93816 8.43815 8.17773 10.8132 8.17773H14.1882C16.5632 8.17773 17.3236 8.93816 17.3236 11.3132Z" fill="currentColor"/>
      <path opacity="0.4" d="M12.5215 19.3848V19.4889C12.5215 21.8743 11.7611 22.6348 9.37565 22.6348H6.01107C3.62565 22.6348 2.86523 21.8743 2.86523 19.4889V16.1244C2.86523 13.7389 3.62565 12.9785 6.01107 12.9785H6.11523V14.6868C6.11523 17.9368 7.56315 19.3848 10.8132 19.3848H12.5215Z" fill="currentColor"/>
    </svg>,
    "StackedLayer",
  ),
);

export default StackedLayer;
